:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._device-switch-wrapper_ulh4u_7 {
  display: flex;
  align-items: center;
  justify-content: center; }
  ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 {
    display: flex;
    height: 100%; }
    ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 ._top-bar-btn-device_ulh4u_14._desktop_ulh4u_14 {
      padding: 0 5px 0 21px;
      border: none; }
    ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 ._top-bar-btn-device_ulh4u_14._mobile_ulh4u_17 {
      padding: 0 21px 0 4px;
      border: none; }
    ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 {
      align-items: center;
      justify-content: center;
      padding: 0 5px; }
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 ._top-bar-btn-content-wrapper_ulh4u_24:after {
        display: none; }
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 ._top-bar-btn-device_ulh4u_14._desktop_ulh4u_14,
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11 ._top-bar-btn-device_ulh4u_14._mobile_ulh4u_17 {
        padding: 0 8px; }
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11._tour-maker-highlight-element_ulh4u_29 {
        background-color: #fff; }
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_ulh4u_11::after {
        z-index: 0;
        content: '';
        width: 34px;
        height: 34px;
        border-radius: 4px;
        pointer-events: none;
        position: absolute;
        background-color: #116dff;
        opacity: 0.1;
        transition: transform 0.2s ease-in-out; }
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_desktop_ulh4u_42::after {
        transform: translate(-20px, 0); }
      ._classic-facelift-skin_ulh4u_20 ._device-switch-wrapper_ulh4u_7 ._top-bar-device-switch_mobile_ulh4u_44::after {
        transform: translate(20px, 0); }
  ._device-switch-wrapper_ulh4u_7 ._device-width-indication_ulh4u_46 {
    width: 50px;
    padding: 0 5px; }
